module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showArchived) ? _c('unit-archived', {
    attrs: {
      "unit": _vm.unit
    }
  }) : _c('unit-current', {
    attrs: {
      "unit": _vm.unit
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f93b48","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unit.vue
// module id = 1119
// module chunks = 1